import { useEffect, useContext, useState, useRef } from "react";
import { cloneDeep } from "lodash";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import { trans } from "../../lib/utils";

function DownloadFeatures(props) {
  const outputFormatList = [
    { label: "CSV", value: "CSV", service: "WMS" },
    {
      label: "GeoJSON",
      value: "application/json",
      contentType: "application/json",
      service: "WFS",
    },
    {
      label: "GeoTIFF",
      value: "image/geotiff",
      contentType: "image/geotiff",
      service: "WMS",
    },
    {
      label: "GML3",
      value: "GML3",
      contentType: "application/gml",
      service: "WFS",
    },
    {
      label: "JPEG",
      value: "image/jpeg",
      contentType: "image/jpeg",
      service: "WMS",
    },
    {
      label: "KML",
      value: "KML",
      contentType: "application/vnd.google-earth.kml+xml",
      service: "WMS",
    },
    {
      label: "PDF",
      value: "application/pdf",
      contentType: "application/pdf",
      service: "WMS",
    },
    {
      label: "PNG",
      value: "image/png",
      contentType: "image/png",
      service: "WMS",
    },
    {
      label: "Shapefile (ZIP)",
      value: "shape-zip",
      contentType: "application/zip",
      service: "WFS",
    },
    {
      label: "SVG",
      value: "image/svg",
      contentType: "image/svg",
      service: "WMS",
    },
  ];

  const [fileProjection, setFileProjection] = useState(null);
  const [fileEncoding, setFileEncoding] = useState(null);
  const [outputFormat, setOutputFormat] = useState({ value: "", type: "WMS" });

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const [layer, setLayer] = useState(null);
  const [featureIds, setFeatureIds] = useState([]);

  useEffect(() => {
    console.log(props);
    setLayer(props.layer.id ? props.layer.id : props.layer);
    if (props.features) {
      setFeatureIds([...props.features]);
    }
  }, []);

  const checkIfAllowedToDownload = () => {
    if (outputFormat.value) {
      switch (outputFormat.type) {
        case "WMS":
          return true;

        case "WFS":
          if (fileEncoding && fileProjection) {
            return true;
          }

          return false;
          break;
        default:
          return false;
      }
    }

    return false;
  };

  function DownloadFile(url, contentType, title) {
    fetch(
      window["appConfig"]()["api"](
        "?proxy=raw&contenttype=".concat(contentType, "&url=", url)
      ),
      {
        method: "GET",
        headers: {},
      }
    )
      .then((response) => response.blob())
      .then((resp) => {
        try {
          const href = URL.createObjectURL(resp);

          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", title);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } catch (e) {}
      });
  }

  const downloadEvent = (featureId) => {
    console.log(layer);
    switch (outputFormat.type) {
      case "WMS":
        const wmsURL = new URL(
          "?REQUEST=GetMap&SERVICE=WMS&VERSION=1.1.1&LAYERS=".concat(
            layers[layer].name,
            "&FORMAT=",
            outputFormat.value,
            "&TRANSPARENT=TRUE&SRS=EPSG:4326&BBOX=",
            layers[layer].bbox.join(","),
            "&WIDTH=800&HEIGHT=600",
            "&FEATUREID=",
            featureId
          ),
          sources[layers[layer].source.id].url
        ).toString();

        DownloadFile(wmsURL, outputFormat.contentType, layers[layer].name);

        break;

      case "WFS":
        let wfsURL = new URL(
          "?REQUEST=GETFEATURE&SERVICE=WFS&VERSION=1.1.0&TYPENAMES=".concat(
            layers[layer].name,
            "&OUTPUTFORMAT=",
            outputFormat.value,
            "&FORMAT_OPTIONS=CHARSET:",
            fileEncoding,
            "&SRSNAME=",
            fileProjection,
            "&FEATUREID=",
            featureId
          ),
          sources[layers[layer].source.id].url
        ).toString();

        DownloadFile(wfsURL, outputFormat.contentType, layers[layer].name);

        break;
    }
  };

  return (
    <div className=" w-100 p-2 h-100">
      <div className="mb-3">
        <label className="color-get-blue strong ">
          {trans("Select output format")}
        </label>
        <div className="mt-2 input-group">
          <select
            className="form-select form-select-sm "
            value={outputFormat.value}
            onChange={(e) => {
              let serviceType = "WMS";
              let contentType = "";
              outputFormatList.forEach((el) => {
                if (el.value == e.target.value) {
                  serviceType = el.service;
                  contentType = el.contentType;
                }
              });

              setOutputFormat({
                value: e.target.value,
                type: serviceType,
                contentType: contentType,
              });
            }}
          >
            <option value="">{trans("Select output format")}</option>
            {outputFormatList.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </select>
        </div>
      </div>
      {outputFormat.type == "WFS" ? (
        <>
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Select projection system")}
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm "
                value={fileProjection}
                onChange={(e) => {
                  setFileProjection(e.target.value);
                }}
              >
                <option value="">{trans("Select projection system")}</option>
                {window["appConfig"]()["projectionSystems"].map((opt) => {
                  return <option value={opt.code}>{opt.title}</option>;
                })}
              </select>
            </div>
          </div>

          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Select character encoding")}
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm "
                value={fileEncoding}
                onChange={(e) => {
                  setFileEncoding(e.target.value);
                }}
              >
                <option value="">{trans("Select character encoding")}</option>
                {window["appConfig"]()["charsets"].map((opt) => {
                  return <option value={opt.value}>{opt.label}</option>;
                })}
              </select>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <div className="md-3 text-end">
        {featureIds.length > 1 ? (
          <>
            <button
              className="btn btn-sm btn-success  me-2"
              onClick={() => {
                featureIds.forEach((el) => {
                  downloadEvent(el);
                });
              }}
              disabled={checkIfAllowedToDownload() ? "" : "disabled"}
            >
              <span className="text-white">{trans("Download separately")}</span>
            </button>
            <button
              className="btn btn-sm btn-primary "
              onClick={() => {
                downloadEvent(featureIds.join(","));
              }}
              disabled={checkIfAllowedToDownload() ? "" : "disabled"}
            >
              <span className="text-white">{trans("Download all in one")}</span>
            </button>
          </>
        ) : (
          <button
            className="btn btn-sm btn-success "
            onClick={() => {
              downloadEvent(featureIds.join(","));
            }}
            disabled={checkIfAllowedToDownload() ? "" : "disabled"}
          >
            <span className="text-white">{trans("Download")}</span>
          </button>
        )}
      </div>
    </div>
  );
}
export default DownloadFeatures;
